// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Chip {
    align-items: center;
    background-color: transparent;
    border: 1px solid var(--palette-gray-separator);
    border-radius: 16px;
    color: var(--palette-text);
    display: inline-flex;
    font-size: 13px;
    height: 32px;
    max-width: 100%;
    vertical-align: middle;
}

.Chip__label {
    background: none;
    border: 0;
    color: inherit;
    font: inherit;
    line-height: 1;
    max-width: 100%;
    overflow: hidden;
    padding: 0 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

button.Chip__label {
    cursor: pointer;
}

.Chip__delete {
    align-items: center;
    background: none;
    border: 0;
    color: inherit;
    cursor: pointer;
    display: flex;
    margin-right: 5px;
    opacity: 0.7;
    padding: 0;
}

.Chip__delete .SvgIcon {
    height: 16px;
    width: 16px;
}

.Chip__delete:hover,
.Chip__delete:focus {
    opacity: 1;
}

.Chip__label:focus-visible,
.Chip__delete:focus-visible {
    outline: 2px solid var(--palette-accent-light);
    outline-offset: -2px;
}

/* The label button carries no padding-right when a delete button follows it. */
.Chip__label + .Chip__delete {
    margin-left: -4px;
}

.Chip.Chip--primary {
    color: var(--palette-trovit-blue);
}

.Chip.Chip--outlined {
    background-color: transparent;
    border-color: currentColor;
}

.Chip.Chip--primary.Chip--outlined {
    border-color: var(--palette-trovit-blue);
}

.Chip.Chip--primary button.Chip__label:hover {
    background-color: var(--palette-trovit-blue-opacity-20);
}
`, "",{"version":3,"sources":["webpack://./js/components/library/html/Chip/Chip.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,+CAA+C;IAC/C,mBAAmB;IACnB,0BAA0B;IAC1B,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,aAAa;IACb,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,8CAA8C;IAC9C,oBAAoB;AACxB;;AAEA,+EAA+E;AAC/E;IACI,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,uDAAuD;AAC3D","sourcesContent":[".Chip {\n    align-items: center;\n    background-color: transparent;\n    border: 1px solid var(--palette-gray-separator);\n    border-radius: 16px;\n    color: var(--palette-text);\n    display: inline-flex;\n    font-size: 13px;\n    height: 32px;\n    max-width: 100%;\n    vertical-align: middle;\n}\n\n.Chip__label {\n    background: none;\n    border: 0;\n    color: inherit;\n    font: inherit;\n    line-height: 1;\n    max-width: 100%;\n    overflow: hidden;\n    padding: 0 12px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\nbutton.Chip__label {\n    cursor: pointer;\n}\n\n.Chip__delete {\n    align-items: center;\n    background: none;\n    border: 0;\n    color: inherit;\n    cursor: pointer;\n    display: flex;\n    margin-right: 5px;\n    opacity: 0.7;\n    padding: 0;\n}\n\n.Chip__delete .SvgIcon {\n    height: 16px;\n    width: 16px;\n}\n\n.Chip__delete:hover,\n.Chip__delete:focus {\n    opacity: 1;\n}\n\n.Chip__label:focus-visible,\n.Chip__delete:focus-visible {\n    outline: 2px solid var(--palette-accent-light);\n    outline-offset: -2px;\n}\n\n/* The label button carries no padding-right when a delete button follows it. */\n.Chip__label + .Chip__delete {\n    margin-left: -4px;\n}\n\n.Chip.Chip--primary {\n    color: var(--palette-trovit-blue);\n}\n\n.Chip.Chip--outlined {\n    background-color: transparent;\n    border-color: currentColor;\n}\n\n.Chip.Chip--primary.Chip--outlined {\n    border-color: var(--palette-trovit-blue);\n}\n\n.Chip.Chip--primary button.Chip__label:hover {\n    background-color: var(--palette-trovit-blue-opacity-20);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
